/**
 * 权限路由守卫组件
 * 检查用户权限，无权限则显示403页面
 */

import React from 'react';
import { Result, Button } from 'antd';
import { checkPermission } from '@/utils/auth';
import { usePageBack } from '@/hooks/usePageBack';

export interface PermissionRouteProps {
  children: React.ReactNode;
  roles?: string[];
  permissions?: string[];
  mode?: 'all' | 'any';
}

const PermissionRoute: React.FC<PermissionRouteProps> = ({
  children,
  roles,
  permissions,
  mode = 'any'
}) => {
  const goBack = usePageBack();

  // 本地开发环境跳过权限检查
  if (import.meta.env.DEV) {
    return <>{children}</>;
  }

  // 如果没有设置权限要求，直接通过
  if (!roles && !permissions) {
    return <>{children}</>;
  }

  // 检查权限
  const hasPermission = checkPermission({
    roles,
    permissions,
    mode,
  });
  
  // 有权限，渲染子组件
  if (hasPermission) {
    return <>{children}</>;
  }
  
  // 无权限，显示403页面
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      background: '#f5f5f5'
    }}>
      <Result
        status="403"
        title="403"
        subTitle="抱歉，您没有访问此页面的权限"
        extra={
          <Button type="primary" onClick={goBack}>
            返回上页
          </Button>
        }
      />
    </div>
  );
};

export default PermissionRoute;